<template>
  <div class="sidebar-area">
    <div class="logo position-relative">
      <RouterLink
        to="/dashboard"
        class="d-flex justify-content-around align-items-center"
      >
        <img src="@/assets/images/logo/logo-small.png" alt="logo-icon" />
      </RouterLink>
    </div>

    <div class="layout-menu menu-vertical menu hover-scroll-bar">
      <ul class="menu-inner">
        <li class="menu-title small text-uppercase">
          <span class="menu-title-text">MAIN</span>
        </li>
        <div v-for="item in listMenu" :key="item.id" class="menu-wrapper">
          <li class="menu-item" v-if="item.children == false">
            <RouterLink :to="item.url" class="menu-link">
              <span class="material-symbols-outlined menu-icon">{{
                item.icon
              }}</span>
              <span class="title">{{ item.name }}</span>
            </RouterLink>
          </li>
          <li
            class="menu-item"
            :class="{ open: isOpen(item.name) }"
            v-if="item.children == true"
          >
            <a
              href="javascript:void(0);"
              class="menu-link menu-toggle"
              @click="toggleMenu(item.name)"
            >
              <span class="material-symbols-outlined menu-icon">{{
                item.icon
              }}</span>
              <span class="title">{{ item.name }}</span>
            </a>

            <ul
              class="menu-sub"
              v-show="isOpen(item.name)"
              v-if="item.children == true"
            >
              <li
                class="menu-item"
                v-for="itemSub in item.sub_menu.sort((a, b) =>
                  a.name.localeCompare(b.name)
                )"
                :key="itemSub.id"
              >
                <RouterLink :to="itemSub.url" class="menu-link">
                  {{ itemSub.name }}
                </RouterLink>
              </li>
            </ul>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import feather from "feather-icons";
import stateStore from "../../utils/store";
import { useAuthStore } from "@/stores/auth";
import { useMenuTree } from "@/stores/master/menu-tree";

export default defineComponent({
  name: "LeftSidebar",
  setup() {
    const stateStoreInstance = stateStore;
    const menuTreeStore = useMenuTree();
    const listMenu = ref();

    const loadMenuTree = async () => {
      const { success, message } = await menuTreeStore.getMenuByRole();
      listMenu.value = await menuTreeStore.menus;
    };

    const authStore = useAuthStore();

    // Reactive state to track which menu items are open
    const openMenu = ref(null);

    // Method to toggle the menu items
    const toggleMenu = (menu) => {
      // If the same menu is clicked, toggle it; otherwise, open the clicked menu
      openMenu.value = openMenu.value === menu ? null : menu;
    };

    // Method to check if a menu is open
    const isOpen = (menu) => {
      return openMenu.value === menu;
    };

    onMounted(async () => {
      feather.replace();
      loadMenuTree();
    });

    return {
      stateStoreInstance,
      toggleMenu,
      isOpen,
      listMenu,
    };
  },
});
</script>
